import '../../../../components/Functions/CodeBlock.scss';
import './ReportLogicList.scss';
import ColumnDefinition from '../../../../infrastructure/types/DataGrid/ColumnDefinition';
import React, { Fragment } from 'react';
import UiDataGrid from '../../../Common/DataGrid/UiDataGrid/UiDataGrid';
import { generateKey } from '../../../../infrastructure/helpers/react/commonHelper';
import DropZone from '../../../Common/Dragging/DropZone/DropZone';

interface ReportLogicListProps<T> {
    isWaiting: boolean;
    items: T[];
    columns: ColumnDefinition<T>[];
    getContent: (item: T) => JSX.Element;
    getKey: (item: T) => number;
    createHtmlId: (item: T) => string;
    onClick?: (e: React.MouseEvent<HTMLElement>, item: T) => void;
    onDropZoneDrop?: (dragIdentifier: number, dropIdentifier: number) => void;
    tableClassName?:string;
}

class ReportLogicList<T> extends React.Component<ReportLogicListProps<T>> {

    constructor(props: ReportLogicListProps<T>) {
        super(props);

        this.onDropZoneDrop = this.onDropZoneDrop.bind(this);
    }

    onDropZoneDrop(dropIndex: number, e: React.DragEvent<HTMLDivElement>): void {

        try {
            const dragNumber = parseInt(JSON.parse(e.dataTransfer.getData('transferData'))['dragIdentifier']);

            this.props.onDropZoneDrop && this.props.onDropZoneDrop(dragNumber, dropIndex + 1);
        }
        catch (error) { }
    }

    render(): JSX.Element {

        if (this.props.isWaiting || this.props.items.length === 0) {
            return (
                <></>
            );
        }
        return (
            <div className="report-logic">

                {this.props.items.map((item, index) => {
                    return (
                        <Fragment key={this.props.createHtmlId(item)} >
                            <div className="item" key={this.props.createHtmlId(item)} id={this.props.createHtmlId(item)}
                                onClick={(e) => { this.props.onClick && this.props.onClick(e, item) }}>

                                <UiDataGrid tableClassName={this.props.tableClassName} key={this.props.createHtmlId(item)} columns={this.props.columns} data={[item]} getKey={(x, i) => i} />

                                {this.props.getContent(item)}
                            </div>
                            <DropZone key={generateKey()} className='height-10px drop-box'
                                onDrop={(e) => this.onDropZoneDrop(index, e)} />
                        </Fragment>
                    );
                })
                }

            </div>
        );
    }
}

export default ReportLogicList;
